import React, { useMemo } from "react";
import ItemsPageGen from "./generated/ItemsPageGen";
import itemsService from "../../../services/legacy/itemsService";

const SHOW_IN_GRID = new Set(["itemId", "itemname", "salesPrice", "blocked"]);
const SHOW_IN_FILTER = new Set(["itemId", "itemname", "blocked"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const ItemsPage = () => {
  const service = useMemo(() => {
    const scopedService = Object.create(itemsService);
    scopedService.getAll = async (page = 0, pageSize = 100, sort = [], filters = {}) => {
      const hasExplicitSort = Array.isArray(sort) && sort.length > 0;
      const effectiveSort = hasExplicitSort ? sort : [{ field: "modifieddate", direction: "desc" }];
      return itemsService.getAll(page, pageSize, effectiveSort, filters);
    };
    return scopedService;
  }, []);

  return <ItemsPageGen service={service} transformColumns={transformColumns} />;
};

export default ItemsPage;
